<template>
  <div>
    <div id="Waves">
      <!-- Header -->
      <div class="header py-7 py-lg-8 pt-lg-9">
        <b-container>
          <div class="header-body text-center mb-7">
            <b-row class="justify-content-center">
              <b-col xl="6" lg="6" md="8" class="px-5">
                <h1 id="welcome" class="text-white">NEW PASSWORD</h1>
                <p class="text-lead text-white">Please enter a new password.</p>
              </b-col>
            </b-row>
          </div>
        </b-container>
      </div>
      <!-- Page content -->
      <b-container class="mt--8 pb-5 login-box">
        <b-row v-if="!loginValue" class="justify-content-center">
          <b-col lg="6" md="7">
            <b-card no-body class="bg-secondary border-0 mb-0">
              <b-card-header class="bg-transparent pb-5 justify-content-center"
              ><h4>Authenticating</h4></b-card-header
              >
              <b-card-body class="px-lg-5 py-lg-5 justify-content-center text-center">
                <div class="text-center w-100 mb-4">
                  <b-icon
                      icon="three-dots"
                      class="text-center"
                      animation="cylon"
                      font-scale="4"
                  ></b-icon>
                </div>
                <p class="justify-content-center">Please wait while we validate your credentials.</p>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>

        <b-row class="justify-content-center" v-if="loginValue">
          <b-col lg="6" md="7">
            <b-card no-body class="bg-secondary border-0 mb-0">
              <b-card-header class="bg-transparent pb-5" style="display: none">
                <div class="text-muted text-center mt-2 mb-3">
                  <small>Sign in with</small>
                </div>
                <div class="btn-wrapper text-center">
                  <a href="#" class="btn btn-neutral btn-icon">
                    <span class="btn-inner--icon"><img src="img/icons/common/github.svg"/></span>
                    <span class="btn-inner--text">Github</span>
                  </a>
                  <a href="#" class="btn btn-neutral btn-icon">
                    <span class="btn-inner--icon"><img src="img/icons/common/google.svg"/></span>
                    <span class="btn-inner--text">Google</span>
                  </a>
                </div>
              </b-card-header>

              <b-card-body class="px-lg-5 py-lg-5">
                <div class="text-center text-muted mb-4">
                  <small>Set a NEW PASSWORD</small>
                </div>
                <validation-observer v-slot="{handleSubmit}" ref="formValidator">
                  <b-form role="form" @submit.prevent="handleSubmit(authenticateUser)">

                    <b-input-group class="mb-4">
                      <b-input-group-prepend>
                        <b-button :variant="validationUsername?'outline-success': 'outline-danger'">
                          <i class="fa fa-user"></i>
                        </b-button>
                      </b-input-group-prepend>
                      <b-form-input
                          id="username"
                          v-model="loginForm.username"
                          :state="validationUsername"
                          placeholder="Input Username"
                          aria-describedby="username-feedback"
                      ></b-form-input>
                      <b-form-invalid-feedback id="username-feedback" :state="validationUsername">
                        Input valid username
                      </b-form-invalid-feedback>
                    </b-input-group>

                    <b-input-group class="mb-4">
                      <b-input-group-prepend>
                        <b-button :variant="validationPassword?'outline-success': 'outline-danger'">
                          <i class="fas fa-key"></i>
                        </b-button>
                      </b-input-group-prepend>
                      <b-form-input
                          id="input-valid"
                          type="password"
                          v-model="loginForm.password"
                          :state="validationPassword"
                          placeholder="Input NEW Password"
                          aria-describedby="password-feedback"
                      ></b-form-input>
                      <b-form-invalid-feedback id="password-feedback" :state="validationPassword">
                        Input valid password
                        <router-link to="/forgot" class="text-light" custom v-slot="{navigate}">
                          <a @keypress.enter="navigate" @click="navigate" role="link">
                            <label for="password"
                                   class="text-sm text-primary cursor-pointer">
                              <small> Forgot Password?</small>
                            </label>
                          </a>
                        </router-link>
                      </b-form-invalid-feedback>
                    </b-input-group>

                    <div class="text-center w-100">
                      <base-button
                          type="primary"
                          native-type="submit"
                          class="my-4 w-100"
                      >Sign in
                      </base-button>
                    </div>
                  </b-form>
                </validation-observer>
                <div class="text-center">
                  <router-link
                      to="/register"
                      class="text-light"
                      v-if="registerStatus>0"
                      custom
                      v-slot="{navigate}"
                  >
                    <a @keypress.enter="navigate" @click="navigate" role="link">
                      <small>Create new account</small></a
                    >
                  </router-link>
                </div>
              </b-card-body>
            </b-card>

          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import AuthService from "@/common/api-services/auth-service";
import initService from "@/common/api-services/init-service";
import sessionIdDirective from "@/common/directive/sessionId-directive";
import configDirective from "@/common/directive/config-directive";
import commonService from "@/common/api-services/common";
import authService from "@/common/api-services/auth-service";
import coreutils from "@/common/coreutils";

export default {
  name: "login",
  data() {
    return {
      loginForm: {
        username: "",
        password: "",
      },
      client: process.env.PORTAL_NAME,
      errorMessage: "",
      loginValue: true,
      registerStatus: 0,
    };
  },

  mounted() {
    //is user authenticated
    if (this.isAuthenticated) {
      //goto dashboard
      this.$router.push({name: "dashboard"});
    } else {
      //cleanup local storage
      sessionStorage.clear();
      localStorage.clear();
      let registerUser = configDirective.getRegisterStatus();
      if (!registerUser) {
        this.registerStatus = 0;
      } else if (registerUser < 1) {
        this.registerStatus = 0;
      } else if (registerUser > 0) {
        this.registerStatus = 1;
      }
    }
    //always set session and render background.
    sessionIdDirective.setSessionId();
    this.$root.$emit("renderBackground", true);
  },

  methods: {
    authenticateUser() {
      if (this.validationUsername && this.validationPassword) {
        this.loginValue = false;
        const username = this.loginForm.username;
        const password = this.loginForm.password;
        let credential = coreutils.base64_encode(username + '|' + password);

        const params = new URLSearchParams(location.search);
        let session = params.get('session');
        //let session = this.$route.params.session;//sessionStorage.getItem('session');

        AuthService.respondNewPasswordChallenge(session, credential)
            .then(res => {
              console.log('respondNewPasswordChallenge:', res);
              if (JSON.stringify(res).includes("FAIL")) {
                this.$toast('Invalid username or password response.', {
                  position: 'top-right',
                  type: 'error',
                  timeout: 5000,
                  icon: true
                });
                return;
              }

              let grp = res.data.message["groups"];
              let accessToken = res.data.message["access_token"];
              if (grp && grp.length > 0) {
                //TODO: why session and current user on local storage... why not all session?
                sessionStorage.setItem("accessToken", accessToken);

                sessionStorage.setItem("IOT_GetCurrentUser", JSON.stringify(res.data.message));
                authService.setActivityLog("AUTH:Login", "Login OK", 0);

                //set default open cards
                initService.resetOpenCards();

                //fix the default route in the Event that Home is missing.
                let redirectPath = "default_home";
                let eSimName = configDirective.getESimName();
                let otaName = configDirective.getOTAName();
                if (eSimName === otaName) {
                  redirectPath = "home";
                } else {
                  redirectPath = "default_home";
                }

                setTimeout(() => {
                  this.$router.push({path: `${redirectPath}`});
                }, 1000);

                setTimeout(() => {
                  this.$root.$emit("stopBackgroundAnimation", true);
                }, 400);

                this.errorMessage = "";
              } else {
                this.loginValue = true;
                // We need to improve upon the login responses.  see: AWSCognitoWrapper.js line 172
                //console.log('debugging login: ', res.data);
                if (res.data.message.indexOf("FAIL") !== -1) {
                  throw new Error("Invalid username or password.");
                }
                authService.setActivityLog("AUTH:Login", "Login OK", 0);
              }
            })
            .catch(err => {
              authService.setActivityLog("AUTH:Login", JSON.stringify(err), 1);
              sessionStorage.removeItem("accessToken");
              sessionStorage.removeItem("IOT_GetCurrentUser"); // if the request fails, remove any possible user token if possible
              this.errorMessage = err.toString().replace("Error:", "");
              this.loginValue = true;
            });
      }
    }
  },
  computed: {

    validationUsername() {
      return (this.loginForm.username.length > 0 && !this.loginForm.username.includes(' '));
    },
    validationPassword() {
      return !!(this.loginForm && this.passwordUppercase && this.passwordNumber && this.passwordCharacter);
    },
    passwordLength() {
      return this.loginForm.password.length > 7
    },
    passwordUppercase() {
      let pass = this.loginForm.password;
      for (let i = 0; i < pass.length; i++) {
        if ('A' <= pass[i] && pass[i] <= 'Z') {
          return true;
        }
      }
    },
    passwordNumber() {
      let pass = this.loginForm.password;
      for (let i = 0; i < pass.length; i++) {
        if ('0' <= pass[i] && pass[i] <= '9') {
          return true;
        }
      }
    },
    passwordCharacter() {
      let format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
      if (format.test(this.loginForm.password)) {
        return true
      }
    }
  },
};
</script>
